import { DEFAULT_PHONE_CODE } from "constants/CountryCodes";
import dayjs, { Dayjs } from "dayjs";

export function formatTime(val: string | Dayjs | Date) {
	if (!val) {
		return "";
	}
	return dayjs(val).format("HH:mm");
}

export function formatDate(val: string | Dayjs | Date) {
	if (!val) {
		return "";
	}
	return dayjs(val).format("ddd D MMM YYYY");
}

export function formatPrice(
	value?: number | string | null,
	decimalPlaces: number = 2 // Default to 2 for currency
): string | undefined {
	if (value === null || value === undefined || value === "") {
		return undefined;
	}

	const numericValue = typeof value === "string" ? parseFloat(value) : value;

	if (isNaN(numericValue)) {
		return String(value);
	}

	return new Intl.NumberFormat("en-NZ", {
		style: "currency",
		currency: "NZD",
		minimumFractionDigits: decimalPlaces,
		maximumFractionDigits: decimalPlaces
	}).format(numericValue);
}

export function stripPhonePrefix(phone: string | null | undefined): string {
	const s = phone ?? "";
	return s.startsWith(DEFAULT_PHONE_CODE) ? s.slice(DEFAULT_PHONE_CODE.length) : s;
}
